module.exports = __webpack_public_path__ + "img/qingfengxian.80efbaf4.png";